import { AnimatePresence, motion } from "framer-motion";
import { useWindowSize } from "./useWindowSize";
import { useEffect, useState } from "react";
import { Bars2Icon, CalendarDaysIcon, CalendarIcon } from "@heroicons/react/24/outline";


const UpcomingEvents = () => {
  const [open, setOpen] = useState("");
  const [allUpcomingEvents, setAllUpcomingEvents] = useState([]);

  useEffect(() => {
    const storedData = sessionStorage.getItem("upcomingEvents");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setAllUpcomingEvents(parsed);
      if (parsed.length > 0) setOpen(parsed[0]._id);
    } else {
      fetch("https://al-maghrib-server.vercel.app/upcomingEvent/all")
        .then((res) => res.json())
        .then((data) => {
          const validEvents = data.upcomingEvents?.filter(
            (e) => e._id && e.date && e.headline && e.img
          );
          if (validEvents?.length) {
            setAllUpcomingEvents(validEvents);
            setOpen(validEvents[0]._id);
            sessionStorage.setItem("upcomingEvents", JSON.stringify(validEvents));
          }
        })
        .catch((err) => {
          console.error("Failed to fetch upcoming events:", err);
        });
    }
  }, []);

  return (
    <section className="p-4 bg-white">
      <div className="w-full max-w-6xl mx-auto mb-8 md:px-8 flex justify-center">
        <h2 className="max-w-lg  text-center text-3xl sm:text-4xl font-bold text-blue-400 tracking-tight my-4">
          Upcoming Events
        </h2>
      </div>
      <div className={`flex flex-col lg:flex-row h-fit ${allUpcomingEvents.length>0 ? "lg:h-[450px]" : ""} w-full max-w-6xl mx-auto  overflow-hidden`}>
      {allUpcomingEvents.length > 0 ? (
  allUpcomingEvents.map((item) => (
    <Panel
      key={item._id}
      open={open}
      setOpen={setOpen}
      id={item._id}
      title={item.date}
      imgSrc={item.img}
      description={item.headline}
    />
  ))
) : (
  <div className="w-full text-center py-12  text-xl">
    No upcoming events at the moment.
  </div>
)}

      </div>
    </section>
  );
};

const Panel = ({ open, setOpen, id, title, imgSrc, description }) => {
  const { width } = useWindowSize();
  const isOpen = open === id;

  return (
    <>
      <button
        className="bg-blue-400 hover:bg-blue-500  transition-colors p-3 border-r-[1px] border-b-[1px] border-slate-200 flex flex-row-reverse lg:flex-col justify-end items-center gap-4 relative group"
        onClick={() => setOpen(id)}
        aria-label={`Open event on ${title}`}
      >
        <span
          style={{ writingMode: "vertical-lr" }}
          className="hidden lg:block text-xl font-light rotate-180 text-white "
        >
          {title}
        </span>
        <span className="block lg:hidden text-xl font-light">{title}</span>
        <div className="w-6 lg:w-full aspect-square  text-white grid place-items-center">
          <CalendarDaysIcon />
        </div>
        <span className="w-4 h-4 bg-white group-hover:bg-slate-50 transition-colors border-r-[1px] border-b-[1px] lg:border-b-0 lg:border-t-[1px] border-slate-200 rotate-45 absolute bottom-0 lg:bottom-[50%] right-[50%] lg:right-0 translate-y-[50%] translate-x-[50%] z-20" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            key={`panel-${id}`}
            variants={width >= 1024 ? panelVariants : panelVariantsSm}
            initial="closed"
            animate="open"
            exit="closed"
            style={{
              backgroundImage: `url(${imgSrc})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            className="w-full h-full overflow-hidden relative bg-black flex items-end"
          >
            <motion.div
              variants={descriptionVariants}
              initial="closed"
              animate="open"
              exit="closed"
              className="px-4 py-2 bg-black/40 backdrop-blur-sm text-white"
            >
              <p>{description}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default UpcomingEvents;

const panelVariants = {
  open: { width: "100%", height: "100%" },
  closed: { width: "0%", height: "100%" },
};

const panelVariantsSm = {
  open: { width: "100%", height: "200px" },
  closed: { width: "100%", height: "0px" },
};

const descriptionVariants = {
  open: {
    opacity: 1,
    y: "0%",
    transition: { delay: 0.125 },
  },
  closed: { opacity: 0, y: "100%" },
};


const items = [
  {
    id: 1,
    title: "18 January, 2025",
    imgSrc:
      "https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
  },
  {
    id: 2,
    title: "Play more",
    imgSrc:
      "https://images.unsplash.com/photo-1541532713592-79a0317b6b77?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=688&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
  },
  {
    id: 3,
    title: "Keep track",
    imgSrc:
      "https://images.unsplash.com/photo-1578450671530-5b6a7c9f32a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
  },
  {
    id: 4,
    title: "Grow faster",
    imgSrc:
      "https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum eius deserunt quia consectetur aliquid obcaecati voluptatibus quos distinctio natus! Tenetur.",
  },
];
